var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-container"},_vm._l((_vm.items),function(item){return _c('v-btn',{key:item.value,staticClass:"tab-link",class:{ active: _vm.isActive(item) },attrs:{"to":item.to}},[_c('v-icon',[_vm._v(_vm._s(item.icon))]),_vm._v(" "+_vm._s(item.title)+" ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }